<template>
  <div class="w-100">
    <div v-if="modelValue?.length" class="d-flex flex-wrap row-gap-2 mb-4 col-gap-2">
      <e-chip v-for="(item, index) in modelValue" :key="index" closable @click:close="removeItem(item)">
        {{ isString(item) ? item : getNestedObjectProperty(item, itemTitle) }}
      </e-chip>
    </div>

    <e-autocomplete
      v-model="modelValue"
      hide-selection
      show-menu-icon
      :items="options"
      :label="label"
      :rules="rules"
      multiple
    >
      <template #prepend-inner>
        <e-icon name="search" class="text-secondary" size="20" />
      </template>
    </e-autocomplete>
  </div>
</template>

<script
  setup
  lang="ts"
  generic="
    T extends Record<string, unknown> | string,
    K extends T extends Record<string, unknown> ? Paths<T> | undefined : undefined
  "
>
import type { InputRules, SelectionValue } from '@/core/types/components/components';
import type { Paths } from '@/core/types/gengeric';
import { EAutocomplete, EChip, EIcon } from '@/core/components/ui';
import { getNestedObjectProperty } from '@/core/utils/object';
import { isString } from '@/core/utils/type-guards';

withDefaults(
  defineProps<{
    options: T[];
    itemTitle?: string;
    itemValue?: K;
    errorMessages?: string[];
    rules?: InputRules;
    label?: string;
  }>(),
  {
    itemTitle: 'name',
  },
);

const modelValue = defineModel<SelectionValue<T, K>[]>({ required: true });

const removeItem = (item: T) => {
  modelValue.value = modelValue.value.filter((i) => i !== item);
};
</script>
